/*jshint esversion: 6 */
/*jshint strict: false */

import * as d3 from 'd3';

let data = [];

function setupGraph() {

    let barHeight = 30;

    let dataHeight = barHeight * data.length;

    let svg = d3.select(".highest-earning-bad .graph svg");

    svg.selectAll("*").remove();

    let margin = {top: 30, right: 10, bottom: 20, left: 10};

    svg.attr('width', svg.node().getBoundingClientRect().width);
    svg.attr('height', ((data.length + 1) * barHeight) + margin.top + margin.bottom);

    let width = svg.attr("width") - margin.left - margin.right,
        height = svg.attr("height") - margin.top - margin.bottom,
        g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    let xScaleScore = d3.scaleLinear()
        .range([0, width / (8/2) - 60])
        .domain([0, d3.max(data, function (d) {
            return d.score;
        })]);

    let xScaleRevenue = d3.scaleLinear()
        .range([0, width / (8/2) - 80])
        .domain([0, d3.max(data, function (d) {
            return d.revenueMillions;
        })]);

    let yScale = d3.scaleBand()
        .rangeRound([0, dataHeight])
        .domain(data.map(function (d) {
            return d.film;
        }));

    g.selectAll("text.film")
        .data(data)
        .enter().append("text")
        .attr("x", width / 2)
        .attr("y", function (d) {
            return yScale(d.film) + yScale.bandwidth() / 2 + 15;
        })
        .attr("dominant-baseline", "hanging")
        .attr("text-anchor", "middle")
        .attr('class', 'film')
        .text(function (d) {
            return d.film;
        });

    g.selectAll("rect.score")
        .data(data)
        .enter().append("rect")
        .attr('title', function (d) {
            return d.film;
        })
        .attr("x", function (d) {
            return (width / 8 * 2) - xScaleScore(d.score);
        })
        .attr("y", function (d) {
            return yScale(d.film) + yScale.bandwidth() / 2 + 15;
        })
        .attr("class", "score")
        .attr("width", function (d) {
            return xScaleScore(d.score);
        })
        .attr("height", yScale.bandwidth() / 1.5);

    g.selectAll("text.score")
        .data(data)
        .enter().append("text")
        .attr("x", 0)
        .attr("y", function (d) {
            return yScale(d.film) + yScale.bandwidth() / 2 + 15;
        })
        .attr("dominant-baseline", "hanging")
        .attr("text-anchor", "start")
        .attr('class', 'score')
        .text(function (d) {
            return d.score;
        });

    g.selectAll("rect.revenue")
        .data(data)
        .enter().append("rect")
        .attr("x", width / 8 * 6)
        .attr("y", function (d) {
            return yScale(d.film) + yScale.bandwidth() / 2 + 15;
        })
        .attr("class", "revenue")
        .attr("width", function (d) {
            return xScaleRevenue(d.revenueMillions);
        })
        .attr("height", yScale.bandwidth() / 1.5);

    g.selectAll("text.revenue")
        .data(data)
        .enter().append("text")
        .attr("x", width)
        .attr("y", function (d) {
            return yScale(d.film) + yScale.bandwidth() / 2 + 15;
        })
        .attr("dominant-baseline", "hanging")
        .attr("text-anchor", "end")
        .attr('class', 'revenue')
        .text(function (d) {
            return '$' + d.revenueMillions + ' M';
        });

    let gHeadings = g.append("g")
        .attr('class', 'headings');

    gHeadings.append("text")
        .attr("x", width / 2)
        .attr("y", 0)
        .attr("dominant-baseline", "hanging")
        .attr("text-anchor", "middle")
        .attr("class", "film title")
        .text("Films");

    gHeadings.append("text")
        .attr("x", width / 8 * 2).attr("y", 0)
        .attr("dominant-baseline", "hanging")
        .attr("text-anchor", "end")
        .attr("class", "score title")
        .text("Badness Score");

    gHeadings.append("text")
        .attr("x", width / 8 * 6)
        .attr("y", 0)
        .attr("dominant-baseline", "hanging")
        .attr("text-anchor", "start")
        .attr("class", "revenue title")
        .text("Opening Weekend (US)");


}

function populateTable() {

    let table = d3.select(".highest-earning-bad .content-table table tbody");

    let tr = table.selectAll("tr")
        .data(data)
        .enter()
        .append("tr");

    tr.append("td").text(function (d) {
        return d.film;
    });

    tr.append("td").text(function (d) {
        return d.score;
    });

    tr.append("td").text(function (d) {
        return '$' + d.revenueMillions + ' M';
    });

}

function loadData(dataDir) {

    d3.csv(dataDir + "highest-earning-bad.csv", function (csvData) {
        csvData.forEach(function (d) {
            d.score = +d.score;
            d.revenueText = d.revenue;
            d.revenue = d.revenue.replace(/[$,£]+/g, "");
            d.revenueMillions = parseInt(parseInt(d.revenue) / 1000000);
        });
        //console.log( data);
        data = csvData;
        populateTable();
        setupGraph();
    });
}

function init(dataDir) {
    loadData(dataDir);
    window.addEventListener("resize", setupGraph);
}

export {init}


// WEBPACK FOOTER //
// ./highest-earning-bad.js